const faq = {
    faq: {
      pageTitle: 'FAQ',
      pageDescription: 'Frequently Asked Questions',
      list: [
        {
          title: 'What is the process about IOPS SPACE?',
          description:
            'Add Spacecraft => Add Contact Profile => Setting Spacecraft and Ground Station => Check and Schedule a Contact => Receive payment request email => Receive Confirmation email after payment => take the data from Spacecraft'
        },
        {
          title: 'How to use IOPS SPACE?',
          description:
            "Please sign up for membership through the website, and then follow the steps question number 2's answer."
        },
        {
          title: 'How can I pay?',
          description:
            'First, when you book the schedule, we send the e-mail with payment account for remit the price.\nSecond, you just remit the total amount, however if you do not remit in 3 days, your booking is canceled.\nLast, if you remit the full amount, we send final Confirmation note! Then your reservation is completed.'
        },
        {
          title: 'When can I take the data?',
          description:
            'A link to download satellite data will be sent to the email you signed up with. Please note that it is stored on the IOPS SPACE server for 30 days and deleted thereafter.'
        },
        {
          title: 'Can I change the confirmed schedule?',
          description:
            'Yes, you can change it at any time (however, within 7 days from the registration time, orbit recalculation is required).'
        },
        {
          title: 'What kind of transmit and receive frequency supports?',
          description:
            `Antenna Specification\n• G/T : S Band(≥ 14dB/k), X Band(≥ 27 dB/k)\n• Antenna Velocity : AZ: 0.1~20°/s, EL: 0.1~20°/s Tilt: 0.1~5°/s\n• Pointing Accuracy : ≤ 0.1°\n• Antenna Diameter(m) : 4.5 m\n• Frequency\n - Tx : 2025 ~ 2120 MHz\n - Rx : 2200 ~ 2300 MHz`
        },
        {
          title: 'What kind of spacecraft can contact?',
          description:
            'We optimized for LEO CubeSat but also support GEO and Deep Space satellites. Our ground station has multiple coverage.'
        },
        {
          title: 'I forgot my password.',
          description:
            'The link to change your password will be sent to the email address you provided when you signed up.'
        }
      ]
    }
  };
  
  export default faq;
  